// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/events.scss
// module id = 31
// module chunks = 3